import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import CreateAttributeDialog from "../Dialogs/CreateAttributeDialog.tsx";

interface AttributePickerProps {
    value: string;
    onChange: (name: string) => void;
    placeholder?: string;
    defaultType?: string;
}

const AttributePicker: React.FC<AttributePickerProps> = ({ value, onChange, placeholder, defaultType }) => {
    const { businessAttributes, fetchBusinessAttributes } = useFlowStore();
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        if (businessAttributes.length === 0) {
            fetchBusinessAttributes();
        }
    }, []);

    const valueExists = !value || businessAttributes.some(a => a.attributeName === value);

    return (
        <div style={{ display: "flex", gap: "6px", alignItems: "center", width: "100%" }}>
            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    flex: 1,
                    minWidth: 0,
                    height: "32px",
                    padding: "4px 8px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "4px",
                    fontSize: "11px",
                    color: "#1e293b",
                    background: "#ffffff",
                    boxSizing: "border-box"
                }}
            >
                <option value="">{placeholder ?? "— Select attribute —"}</option>
                {!valueExists && (
                    <option value={value}>{value} (missing)</option>
                )}
                {businessAttributes.map((attr) => (
                    <option key={attr.attributeId} value={attr.attributeName}>
                        {attr.attributeName} ({attr.attributeType})
                    </option>
                ))}
            </select>
            <button
                type="button"
                onClick={() => setDialogOpen(true)}
                title="Create new attribute"
                style={{
                    flex: "0 0 auto",
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "var(--primary-bg-color)",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    padding: 0
                }}
            >
                <Plus size={14} />
            </button>

            <CreateAttributeDialog
                isOpen={dialogOpen}
                onClose={() => setDialogOpen(false)}
                defaultType={defaultType}
                onCreated={(name) => onChange(name)}
            />
        </div>
    );
};

export default AttributePicker;
